import { render, staticRenderFns } from "./usermessage.vue?vue&type=template&id=5c5159bc&scoped=true"
import script from "./usermessage.vue?vue&type=script&lang=js"
export * from "./usermessage.vue?vue&type=script&lang=js"
import style0 from "./usermessage.vue?vue&type=style&index=0&id=5c5159bc&prod&lang=scss&scoped=true"
import style1 from "./usermessage.vue?vue&type=style&index=1&id=5c5159bc&prod&lang=css"
import style2 from "./usermessage.vue?vue&type=style&index=2&id=5c5159bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5159bc",
  null
  
)

export default component.exports